
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M506.56 208.06l-242.7-177.7a13.3 13.3 0 00-15.716 0l-242.7 177.7c-5.928 4.341-7.216 12.665-2.875 18.593s12.666 7.214 18.593 2.875l234.84-171.94 234.84 171.94a13.236 13.236 0 007.848 2.57c4.096 0 8.138-1.885 10.744-5.445 4.342-5.927 3.054-14.251-2.874-18.592z"}}),_c('path',{attrs:{"d":"M442.25 232.54c-7.346 0-13.303 5.956-13.303 13.303v211.75h-106.42v-115.59c0-36.68-29.842-66.52-66.52-66.52s-66.52 29.842-66.52 66.52v115.59H83.067v-211.75c0-7.347-5.957-13.303-13.303-13.303s-13.303 5.956-13.303 13.303v225.05c0 7.347 5.957 13.303 13.303 13.303h133.03c6.996 0 12.721-5.405 13.251-12.267.032-.311.052-.651.052-1.036v-128.89c0-22.009 17.905-39.914 39.914-39.914s39.914 17.906 39.914 39.914v128.89c0 .383.02.717.052 1.024.524 6.867 6.251 12.279 13.251 12.279h133.03c7.347 0 13.303-5.956 13.303-13.303v-225.05c-.001-7.348-5.957-13.304-13.304-13.304z"}})])
          )
        }
      }
    